import type { ReadonlyDeep } from 'type-fest';

import { MissionInput } from '@e-socna/data-layer';
import { EMPTY_OBJECT } from '@e-socna/empty';
import { EMPTY_ID } from '@e-socna/empty-client';

import { pruneInput } from '../../../utils/prune-input.util';

import { codingConfigForm2ApiMapper } from '../../CodingConfig/mappers/coding-config.form2api.mapper';
import { addressForm2ApiMapper } from '../../Address/mappers/address.form2api.mapper';
import { actorForm2ApiMapper } from '../../Actor/mappers/actor.form2api.mapper';

import type { MissionInput as IMissionInput } from '../hooks/useInitMissionMutation.hook';
import type { MissionForm_Mission } from '../fragments/mission.fragment';

export function missionForm2ApiMapper(
  mission: ReadonlyDeep<MissionForm_Mission>,
): ReadonlyDeep<IMissionInput> {
  const {
    color,
    internalActors: _internalActors,
    externalActors: _externalActors,
    address: _address,
    ...missionInput
  } = pruneInput(mission, MissionInput);

  const address = mission.address
    ? addressForm2ApiMapper(mission.address)
    : null;
  const internalActors = mission.internalActors
    ? mission.internalActors.map(actorForm2ApiMapper)
    : null;
  const externalActors = mission.externalActors
    ? mission.externalActors.map(actorForm2ApiMapper)
    : null;

  return {
    ...missionInput,
    // A collaboration has no category: its form keeps the empty default.
    categoryParentId:
      missionInput.categoryParentId === EMPTY_ID
        ? null
        : missionInput.categoryParentId,
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    categoryLeaf: missionInput.categoryLeaf?.trim() || null,
    title: missionInput.title ?? null,
    description: missionInput.description ?? null,
    address,
    internalActors,
    externalActors,
    ...(color ? { color } : EMPTY_OBJECT),
    codingConfig: codingConfigForm2ApiMapper(mission.codingConfig),
  };
}
